import { CircleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useProvider } from '../../../hooks/useProvider';
import { Alert, AlertDescription, AlertTitle } from '../../shadcn/Alert';
import { Button } from '../../shadcn/Button';
import { UniLoginLayout } from './screen-layout';

/** The browser session belongs to another account than the one this link reconnects. */
export function UniLoginAccountMismatch({ onRetry }: { onRetry: () => void }) {
  const { t } = useTranslation();
  const { provider_name } = useProvider();

  return (
    <UniLoginLayout
      actions={
        <>
          <Button variant="outline" type="button" onClick={onRetry}>
            {t('LoginScreen.unilogin.retry_account', { ns: 'translation', provider: provider_name })}
          </Button>
        </>
      }
    >
      <Alert variant="red">
        <CircleAlert />
        <AlertTitle>{t('LoginScreen.unilogin.account_mismatch.title', { ns: 'translation' })}</AlertTitle>
        <AlertDescription>
          {t('LoginScreen.unilogin.account_mismatch.description', { ns: 'translation', provider: provider_name })}
        </AlertDescription>
      </Alert>
    </UniLoginLayout>
  );
}
